<template>
  <div v-if="isShow" class="toast_wrapper" id="__Toast_Id" @touchmove.prevent>
    <div class="toast_maintain">
      <div
        class="toast_msgbox"
        :style="{ transform: expandBool ? 'scale(1.1)' : 'scale(1)' }"
        v-html="message"
      ></div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, defineExpose } from "vue";

let toastTimer: number | null = null;

const message = ref("");
const isShow = ref(false);
const expandBool = ref(false);

function show(msg: string, time = 3000, expand?: boolean) {
  expandBool.value = !!expand;
  if (toastTimer) window.clearTimeout(toastTimer);
  message.value = msg;
  isShow.value = true;
  toastTimer = window.setTimeout(() => {
    isShow.value = false;
  }, time);
}
function hide() {
  if (toastTimer) window.clearTimeout(toastTimer);
  isShow.value = false;
}

defineExpose({ show, hide });
</script>

<style lang="scss" scoped>
.toast_wrapper {
  box-sizing: border-box;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;

  width: 100%;
  height: 100%;
  padding-bottom: 15%;
  background: rgba(0, 0, 0, 0);
  .toast_maintain {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    position: relative;
    width: 100%;
    height: 100%;
    .toast_msgbox {
      box-sizing: border-box;
      max-width: 81.4%;
      padding: 8px 14px;
      margin: 0 auto;

      background-color: rgba(0, 0, 0, 0.88);
      color: #fff;
      font-size: 14px;
      border-radius: 4px;
      text-align: center;
    }
  }
}
</style>